import useNotificationStore from '../../services/notificationStore'
import { ui } from '../../styles/ui'

const BANNER_STYLE = {
  warning: ui.states.warning,
  error: ui.states.error,
  info: ui.states.loading,
  success: ui.states.success,
}

export default function NotificationBannerHost() {
  const banners = useNotificationStore((state) => state.banners)
  const removeBanner = useNotificationStore((state) => state.removeBanner)

  if (!banners?.length) return null

  return (
    <div className="fixed left-0 right-0 top-0 z-40 flex flex-col gap-2 px-4 pt-3">
      {banners.map((banner) => (
        <div key={banner.id} role="alert" className={`${BANNER_STYLE[banner.severity] || BANNER_STYLE.warning} shadow-sm`}>
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide">{banner.title}</p>
              <p className="mt-1 text-sm break-words">{banner.message}</p>
            </div>
            <button type="button" className={ui.buttons.smGhost} onClick={() => removeBanner(banner.id)}>
              Dismiss
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}
